import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import { Button, Checkbox, TextField } from '@mui/material';
import Modal from '@mui/material/Modal';
import React, { useContext } from 'react';
import Grid from '@mui/material/Grid';
import Input from '@mui/material/Input';
import FormControlLabel from '@mui/material/FormControlLabel';
import { MeetupContext } from '@/MeetupContext';
import { Link, useParams } from 'react-router-dom';
import { Link as LinkCore } from '@mui/material';
import FormLabel from '@mui/material/FormLabel';
import RadioGroup from '@mui/material/RadioGroup';
import { RegFormType, SystemFieldType } from '@/api';
import Radio from '@mui/material/Radio';
import { useForm } from 'react-hook-form';
import { ECTextField } from '@/components/Forms/ECTextField';
import { ECRadioGroupField } from '@/components/Forms/ECRadioGroupField';
import { fieldKey } from '../../VisitorList/components/ImportXLS/import_utils';
import { ECMultiCheckboxField } from '@/components/Forms/ECMultiCheckboxField';
import * as _ from 'underscore';
import CardBlock from '@/components/CardBlock/CardBlock';

const PREFIX = 'MatchingSettings';

const classes = {
  groupLabel: `${PREFIX}-groupLabel`,
};

const StyledCardBlock = styled(CardBlock)(({ theme }) => ({
  [`& .${classes.groupLabel}`]: {
    paddingTop: 12, //theme.spacing(1)
  },
}));

const MatchingSettings = props => {
  const { className, fields, regForm, save, ...rest } = props;
  const { mid: meetupId } = useParams();

  const form = useForm();

  const handleSave = data => {
    //save(data, form)
  };

  return (
    <StyledCardBlock title={'Настройка матчинга'} form={form} save={handleSave}>
      <Grid container spacing={3} style={{ margin: '0px' }}>
        <Grid size={12}>
          <Typography style={{ color: '#546e7a' }}>
            Для того, чтобы показ анкет был менее рандомный, вы можете настроить по каким полям в анкете делать матчинг.
            В таком случае бот будет анализировать информацию из указанных полей и в первую очередь предлагать наиболее
            подходящие анкеты.
          </Typography>
        </Grid>

        <Grid className={classes.groupLabel} size={4}>
          <FormLabel component='legend' style={{ color: '#546e7a' }}>
            Сопоставлять поле из одной анкеты:
          </FormLabel>
        </Grid>
        <Grid size={8}>
          <Typography>тут выбор</Typography>
        </Grid>
        <Grid className={classes.groupLabel} size={4}>
          <FormLabel component='legend' style={{ color: '#546e7a' }}>
            С полем в другой анкете:
          </FormLabel>
        </Grid>
        <Grid size={8}>
          <Typography>тут выбор</Typography>
        </Grid>
        <Grid className={classes.groupLabel} size={4}>
          <FormLabel component='legend' style={{ color: '#546e7a' }}>
            Действие после матчинга:
          </FormLabel>
        </Grid>
        <Grid size={8}>
          <Typography>тут выбор</Typography>
        </Grid>
      </Grid>
    </StyledCardBlock>
  );
};

export default MatchingSettings;
